module.exports = __webpack_public_path__ + "static/media/Triestina.1847d486.png";